import { Toast as BaseUIToast } from '@base-ui/react/toast';
import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';
import { mq } from '@hrworks/design-system/utilities';

const Viewport = styled(BaseUIToast.Viewport)(({ theme }) => ({
  filter: theme.eclipseTier2Color.surface.elevation.shadow.overlay.dropShadow,
  position: 'fixed',
  zIndex: theme.variables.zIndex.notifications,
  right: 30,
  bottom: 30,
  width: 400,

  [mq.isSmallDevice]: {
    right: 6,
    left: 6,
    bottom: 65,
    width: 'auto',
  },
}));

const components = { Viewport };

export const S = {
  ...components,
  ...createClassNames('ToastViewport', components),
} as const;
